module.exports = __webpack_public_path__ + "img/thomas-dutronc.bf2e4e09.jpg";